module.exports = __webpack_public_path__ + "static/media/newIntro.1897eab7.mp4";